import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { EmbeddedNaptarSzolgaltatasPage } from './embedded-naptar-szolgaltatas.page';

const routes: Routes = [
  {
    path: '',
    component: EmbeddedNaptarSzolgaltatasPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EmbeddedNaptarSzolgaltatasPageRoutingModule {}
